import { ContainerLayout, SupportListLoading } from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <div className="mt-6 px-6">
        <SupportListLoading listItemCount={10} />
      </div>
    </ContainerLayout>
  );
}
